import HttpService from '../../services/HttpService';
import ErrorSwitchCase from '../../services/ErrorHandlerService';
import { ADMIN_PATH } from '../../url';

const _axios = HttpService.getAxiosClient();

export const registerAdmin = async (adminData) => {
  try {
    const response = await _axios.post(`${ADMIN_PATH}/admin/register`, adminData);
    return ErrorSwitchCase(response);
  } catch (error) {
    return ErrorSwitchCase(error.response?.data);
  }
};
